import "core-js/modules/es.object.from-entries";
import _slicedToArray from "/workdir/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(' ');
}

function variationName(name, value) {
  return "".concat(name).concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
}

function sanitizeCustomProperties(styles) {
  var nonNullValues = Object.entries(styles).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        value = _ref2[1];

    return value != null;
  });
  return nonNullValues.length ? Object.fromEntries(nonNullValues) : undefined;
}

export { classNames, sanitizeCustomProperties, variationName };